module.exports = __webpack_public_path__ + "3bb921ba529186b52db685cdfa64a9ce.png";